import React, { useEffect } from "react";
import {
  ProjectSection,
  ProjectWrapper,
  ProjectHeading,
  ProjectCardSubTitleBorder,
  ProjectCard,
  ProjectCardDesc,
  ProjectCardMeta,
  ProjectCardSubTitle,
  ProjectCardTitle,
  ProjectLink,
  ProjectContainer,
  ProjectCardElements,
  ProjectCardElement,
  ProjectCardDivElement,
  ProjectSectionDes,
  ProjectCardButtons,
  AppButton,
} from "./Projects.elements";
import { slidesInfo } from "./Slides";
import Aos from "aos";
import "aos/dist/aos.css";
import SwiperCore, { Navigation, Pagination, EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css";
SwiperCore.use([Pagination, Navigation, EffectCoverflow]);

export default function Projects({ id, light }) {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <ProjectSection id={id} className="seccion" light={light}>
      <ProjectWrapper
        data-aos="zoom-in"
        data-aos-duration="5000"
        data-aos-delay="150"
        light={light}
      >
        <ProjectHeading light={light}>PROYECTOS</ProjectHeading>
        <ProjectSectionDes light={light}>
          Proyectos realizados a lo largo de la carrera tanto académicos como
          complementarios
        </ProjectSectionDes>
        <ProjectContainer light={light}>
          <Swiper
            navigation={true}
            effect={"coverflow"}
            centeredSlides={true}
            slidesPerView={window.innerWidth < 760 ? 1 : "auto"}
            loop={true}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            pagination={{
              clickable: true,
            }}
            className="mySwiper"
          >
            {slidesInfo.map((slide, index) => (
              <SwiperSlide key={index}>
                <ProjectCard light={light}>
                  <ProjectCardMeta>
                    <ProjectCardTitle light={light}>
                      {slide.title}
                    </ProjectCardTitle>
                    <ProjectCardSubTitle light={light}>
                      {slide.date}
                    </ProjectCardSubTitle>
                    <ProjectCardSubTitleBorder light={light} />
                    <ProjectCardElements light={light}>
                      <ProjectCardDivElement>
                        Tipo:
                        <ProjectCardElement> {slide.app}</ProjectCardElement>
                      </ProjectCardDivElement>
                      <ProjectCardDivElement>
                        Participantes:
                        <ProjectCardElement>{slide.par}</ProjectCardElement>
                      </ProjectCardDivElement>

                      <ProjectCardDivElement>
                        Para:
                        <ProjectCardElement>{slide.asig}</ProjectCardElement>
                      </ProjectCardDivElement>
                    </ProjectCardElements>
                    <ProjectCardDesc light={light}>
                      {slide.desc}
                    </ProjectCardDesc>
                  </ProjectCardMeta>

                  {slide.web ? (
                    <ProjectCardButtons>
                      <ProjectLink href={slide.urls} target="_blank">
                        <AppButton light={light}>Servidor</AppButton>
                      </ProjectLink>
                      <ProjectLink href={slide.urlc} target="_blank">
                        <AppButton light={light}>Cliente</AppButton>
                      </ProjectLink>
                    </ProjectCardButtons>
                  ) : (
                    <ProjectCardButtons>
                      <ProjectLink href={slide.url} target="_blank">
                        <AppButton light={light}>Código</AppButton>
                      </ProjectLink>
                    </ProjectCardButtons>
                  )}
                </ProjectCard>
              </SwiperSlide>
            ))}
          </Swiper>
        </ProjectContainer>
      </ProjectWrapper>
    </ProjectSection>
  );
}

/**<ProjectLink href={slide.url} target="_blank">
                    <ImgWrapper>
                      <ProjectCardImg src={slide.src} alt={slide.alt} />
                      <div className="capa">
                        <ProjectIcon>
                          <IoMdAddCircle />
                        </ProjectIcon>

                        <h2>Ver código</h2>
                      </div>
                    </ImgWrapper>
                  </ProjectLink> */
